// Ubicaciones que pueden ser origen o destino de un viaje (Bitacora, Logistica "Cambiar destino", Rutas).
// Las del modulo de Siniestros (puestos, rutas y zonas de siniestro, codigo UUID) NO: se veian en esos combos y
// confundian. Caso real: el 20/10/2026 una bitacora tomo «SAN GENARO [702]» (un puesto de siniestro) como destino.
// Tipos del maestro UBI-0000-0000 (medido en produccion el 26/10/2026).
export const TIPOS_SINIESTRO = ['UBI-0000-0000-0004', 'UBI-0000-0000-0005', 'UBI-0000-0000-0006'];
const NOMBRES_SINIESTRO = ['SINIESTRO', 'ZONA SINIESTRO', 'RUTA SINIESTRO'];

export const esDeSiniestro = (u) => {
    const t = u && u.tipoUbicacion;
    if (!t) return false;
    return TIPOS_SINIESTRO.includes(t.codigo) || NOMBRES_SINIESTRO.includes(String(t.nombre || '').trim().toUpperCase());
};

export const ubicacionesDeViaje = (lista) => (Array.isArray(lista) ? lista : []).filter((u) => !esDeSiniestro(u));
